import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Star, Check } from 'lucide-react';
const reviewImages = ['https://cdn.magicpatterns.com/uploads/pjbQhA7jMXF89R8eX3TBgY/2026-06-24_14_30_48-Clipboard.png', 'https://cdn.magicpatterns.com/uploads/ghkDzutLvSdgcGBE5H5JgB/2026-06-24_14_30_28-Clipboard.png', 'https://cdn.magicpatterns.com/uploads/2eiKDNkRm3tuMSuY4q5pEt/2026-06-24_14_33_24-Clipboard.png', 'https://cdn.magicpatterns.com/uploads/3J4YrS1nUiXVxxfJ2kVHTX/2026-06-24_14_33_10-Clipboard.png', 'https://cdn.magicpatterns.com/uploads/ukc2nHNF6aX56FcSKZYy7p/2026-06-24_14_32_11-Clipboard.png', 'https://cdn.magicpatterns.com/uploads/qq8wjFzBmY2c5sBGqU8rnJ/2026-06-24_14_32_28-Clipboard.png'];
export function SocialProof() {
  return <section className="py-[64px] md:py-[96px] bg-bg-primary overflow-hidden" data-id="element-254">
      <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-12" data-id="element-256">
          <h2 className="text-[32px] md:text-[48px] font-[900] mb-4 text-white uppercase" data-id="element-257">
            LO QUE DICEN LOS AGENTES QUE YA LO USAN
          </h2>
          <p className="text-text-secondary text-[18px] font-[500]" data-id="element-258">
            Comentarios reales de agentes que ya completaron el sistema
            VideoInmo AI
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px] mb-16" data-id="element-259">
          {reviewImages.map((imgUrl, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-bg-card border border-border-card rounded-[16px] p-4 hover:-translate-y-[6px] hover:border-accent-border hover:shadow-[0_12px_40px_rgba(0,180,230,0.1)] transition-all duration-250 flex flex-col justify-center items-center overflow-hidden" data-id="element-260">
              <img src={imgUrl} alt={`Testimonio ${idx + 1}`} className="w-full h-auto object-contain rounded-[8px]" data-id="element-261" />
            </motion.div>)}
        </div>
      </div>

      {/* Ticker */}
      <div className="w-full bg-bg-secondary py-4 border-y border-border-subtle overflow-hidden flex whitespace-nowrap" data-id="element-262">
        <div className="animate-ticker flex items-center gap-4 text-text-secondary text-[15px]" data-id="element-263">
          {[...Array(2)].map((_, i) => <Fragment key={i} data-id="element-264">
              <span data-id="element-265">Rolando Garcia: 'super recomendado!'</span>
              <span className="text-accent font-bold" data-id="element-266">·</span>
              <span data-id="element-267">Wendy Menendez: '¡Excelente!!!!'</span>
              <span className="text-accent font-bold" data-id="element-268">·</span>
              <span data-id="element-269">Bryan Vela Paredes: 'Muy bueno'</span>
              <span className="text-accent font-bold" data-id="element-270">·</span>
              <span data-id="element-271">Albert Flores: 'Me sirvió mucho'</span>
              <span className="text-accent font-bold" data-id="element-272">·</span>
            </Fragment>)}
        </div>
      </div>
    </section>;
}